import {Page} from '../../../src/common/constant/page';
import {getWebviewProps} from '../../../src/common/function';
import {IKwPage} from '../../../src/common/type';
import CustomerCenterV4 from '../../../src/more/container/CustomerCenterV4';

interface IProps {
  isWebview: boolean;
  space: number;
}

interface IQuery {
  space?: string;
}

const CustomerCenterPage: IKwPage<IProps, IQuery> = ({isWebview, space}) => {
  return (
    <div style={{marginTop: `${space}px`}}>
      <CustomerCenterV4 isWebview={isWebview} />
    </div>
  );
};

CustomerCenterPage.initialPageProps = {
  page: Page.MoreCustomerCenter,
  getPageTitle: i18next => i18next.t('more_customer'),
};

CustomerCenterPage.getInitialProps = ({userAgent, query}) =>
  getWebviewProps({userAgent, query});

export default CustomerCenterPage;
